const HANDLE_PATTERN = /^[A-Za-z0-9_-]{43}$/;

export function getMcpAuthorizationHandle(search) {
    const parameters = new URLSearchParams(search);
    const values = parameters.getAll('request');
    if ([...parameters.keys()].some((key) => key !== 'request') || values.length !== 1 || !HANDLE_PATTERN.test(values[0])) {
        return null;
    }

    return values[0];
}

export function getSafeMcpReturnPath(value) {
    if (typeof value !== 'string' || !value.startsWith('/oauth/authorize?')) return null;

    const url = new URL(value, 'https://datixo.invalid');
    return url.origin === 'https://datixo.invalid' && getMcpAuthorizationHandle(url.search) !== null
        ? `${url.pathname}${url.search}`
        : null;
}

export function getAnalyticsPath(pathname, search = '') {
    if (pathname === '/oauth/authorize') return pathname;
    if (pathname === '/sign/in') {
        const returnTo = new URLSearchParams(search).get('returnTo');
        if (getSafeMcpReturnPath(returnTo) !== null) return pathname;
    }
    return `${pathname}${search}`;
}

export async function requestMcpConsent({api, handle, action = null}) {
    if (!HANDLE_PATTERN.test(handle) || !api) throw new Error('invalid_request');

    try {
        if (action === null) return await api.mCPAuthorizationRequestDetail({handle});
        if (action === 'approve') {
            return await api.approveMCPAuthorizationRequest({
                handle,
                body: {},
            });
        }
        if (action === 'deny') return await api.denyMCPAuthorizationRequest({handle, body: {}});
        throw new Error('invalid_request');
    } catch (requestError) {
        if (requestError?.message === 'invalid_request') throw requestError;

        const response = requestError?.response;
        const body = await response?.clone?.().json().catch(() => ({})) ?? {};
        throw new Error(body.error ?? (response?.status === 400 ? 'invalid_request' : 'request_failed'));
    }
}
